export const arrayToCommaString = (
  arr: string[],
  translatedAnd: string,
  oxfordComma = false,
) => {
  if (arr.length < 2) {
    return arr.join(', ');
  }
  if (arr.length === 2) {
    return `${arr[0]} ${translatedAnd} ${arr[1]}`;
  }
  const leadingItems = arr.slice(0, -1).join(', ');
  const separator = oxfordComma ? `, ${translatedAnd} ` : ` ${translatedAnd} `;
  return `${leadingItems}${separator}${arr[arr.length - 1]}`;
};
